import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthenticationService } from "./services/authentication.service";

const routes: Routes = [
  { path: "", redirectTo: "signin", pathMatch: "full" },

  { path: "signin", component: LoginComponent },

  // { path: 'ForgotPassword', component: ForgotPasswordComponent },

  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthenticationService],
    children: [
      {
        path: "",
        loadChildren:
          "./layouts/admin-layout/admin-layout.module#AdminLayoutModule"
      }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: false
    })
  ],
  exports: []
})
export class AppRoutingModule {}
